import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../lib/auth";
import { LOGO_URL } from "../lib/constants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setAuthFromGoogle } = useAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        // Clean the hash immediately
        if (window.history?.replaceState) {
            window.history.replaceState(null, "", window.location.pathname);
        }

        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                setToken(data.access_token);
                setAuthFromGoogle(data.user);
                navigate("/dashboard", { replace: true });
            } catch (e) {
                navigate("/login?google_error=1", { replace: true });
            }
        })();
    }, [navigate, setAuthFromGoogle]);

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 bg-brand-cream">
            <img src={LOGO_URL} alt="RENOVA360" className="h-14 w-14 object-contain" />
            <div className="h-8 w-8 rounded-full border-2 border-brand-gold border-t-transparent animate-spin" />
            <div className="eyebrow text-brand-gold">Accesso in corso…</div>
        </div>
    );
}
